<template>
    <div class="flex flex-col justify-center space-y-32">
        <div class="w-full">
            <applications
                ref="applicationsGraph"
                :filterFields="filterFields"
                :class="defaultCardClasses"
            ></applications>
        </div>
        <div class="w-full">
            <div class="flex justify-between">
                <div class="small-block">
                    <job-reasons
                        ref="jobReasonsRequested"
                        :filter-fields="filterFields"
                        :class="defaultCardClasses"
                    ></job-reasons>
                </div>
                <div class="small-block">
                    <job-reasons
                        ref="jobReasonsRejected"
                        :filter-fields="filterFields"
                        :class="defaultCardClasses"
                        rejected
                    ></job-reasons>
                </div>
            </div>
        </div>
        <div class="w-full">
            <job-outstanding
                ref="jobOutstandingGraph"
                :filter-fields="filterFields"
                :class="defaultCardClasses"
            ></job-outstanding>
        </div>
        <div class="w-full">
            <div class="flex justify-between">
                <div class="small-block">
                    <intake
                        ref="intakeBest"
                        :filter-fields="filterFields"
                        type="best"
                        :class="defaultCardClasses"
                    ></intake>
                </div>
                <div class="small-block">
                    <intake
                        ref="intakeWorst"
                        :filter-fields="filterFields"
                        type="worst"
                        :class="defaultCardClasses"
                    ></intake>
                </div>
            </div>
        </div>
        <div class="w-full">
            <recruiting-budget
                ref="recruitingBudgetGraph"
                :filter-fields="filterFields"
                :class="defaultCardClasses"
            ></recruiting-budget>
        </div>
        <div class="w-full">
            <hire-time
                ref="hireTimeGraph"
                :filter-fields="filterFields"
                :class="defaultCardClasses"
            ></hire-time>
        </div>
        <div class="w-full">
            <status-applicants
                ref="statusApplicantsGraph"
                :filter-fields="filterFields"
                :class="defaultCardClasses"
            >
            </status-applicants>
        </div>
        <div class="hide-from-print w-full">
            <vacancies-dates
                ref="vacanciesDatesGraph"
                :filterFields="filterFields"
                :class="defaultCardClasses"
            />
        </div>
    </div>
</template>

<script>
// apexcharts imports
import Applications from './Applications.vue';
import JobOutstanding from "./JobOutstanding.vue";
import JobReasons from "./JobReasons";
import Intake from "./Intake";
import HireTime from "./HireTime";
import RecruitingBudget from "./RecruitingBudget";
import StatusApplicants from "./StatusApplicants.vue";
import VacanciesDates from "./VacanciesDates.vue";

import * as analytics from '../../services/AnalyticsService';
import {extendMoment} from "moment-range";
import Moment from "moment/moment";

const moment = extendMoment(Moment);

export default {
    name: 'TabVacancies',
    components: {
        VacanciesDates,
        Applications,
        JobOutstanding,
        JobReasons,
        Intake,
        HireTime,
        RecruitingBudget,
        StatusApplicants,
    },
    props: {
        filterFields: {type: Object},
        defaultCardClasses: {type: String},
    }
}
</script>

<style scoped>
    .small-block {
        width: 49%;
    }
</style>
